<template>
  <div class="page">
    <van-nav-bar
      :title="'Mandate - ' + code"
      left-arrow
      @click-left="$router.back()"
    />
    <CommonLoading ref="commonLoader"></CommonLoading>

    <div class="content">

      <div v-if="mandateLoading" class="emptyState">
        Loading...
      </div>

      <div v-else-if="mandateList.length === 0" class="emptyState">
        暂无委托记录
      </div>

      <div v-else>
        <div class="mandateCard" v-for="(row, index) in mandateList" :key="index">
          <div class="cardTop">
            <div class="cardTitleRow">
              <div class="cardTitle">{{ row.start_time }}</div>
            </div>
            <span class="periodBadge">{{ row.period }} days</span>
          </div>

          <div class="statGrid">
            <div class="statItem">
              <div class="statLabel">Estimated Share</div>
              <div class="statValue">{{ row.estimated_share }}</div>
            </div>
            <div class="statItem">
              <div class="statLabel">Current Share</div>
              <div class="statValue">{{ row.current_share }}</div>
            </div>
            <div class="statItem">
              <div class="statLabel">Cash Balance</div>
              <div class="statValue">{{ row.cash_balance }}</div>
            </div>
            <div class="statItem">
              <div class="statLabel">Profit/Loss</div>
              <div
                class="statValue"
                :class="{ profitPositive: Number(row.profit_loss) > 0, profitNegative: Number(row.profit_loss) < 0 }"
              >
                {{ row.profit_loss }}
              </div>
            </div>
          </div>

          <div class="cardActions">
            <button class="btnPrimary" @click="onDetail(row)">Insights</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonLoading from "./CommonLoading";
export default {
  name: "AITradeMandate",
  components: {
    CommonLoading,
  },
  data() {
    return {
      depot: null,
      code: "",
      mandateList: [],
      mandateLoading: false,
    };
  },
  methods: {
    getMandateLog() {
      let that = this;
      that.mandateLoading = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "depot_mandate_log",
            token: sessionStorage.getItem("token"),
            depot: that.depot,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.mandateList = res.data.data || [];
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.mandateLoading = false;
        });
    },

    onDetail(row) {
      this.$router.push({
        path: "/ai_trade_depot/mandate/detail",
        query: {
          reference: row.reference,
        },
      });
    },
  },
  mounted: function () {
    this.depot = this.$route.query.depot;
    this.code = this.$route.query.code || "";
    this.getMandateLog();
  },
};
</script>

<style scoped>
.page {
  background: #f7f8fa;
  min-height: 100vh;
}

.content {
  padding: 12px 12px 30px;
}

.emptyState {
  text-align: center;
  padding: 40px 0;
  color: #969799;
  font-size: 14px;
}

.mandateCard {
  background: #ffffff;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0edff;
}

.cardTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.cardTitleRow {
  display: flex;
  align-items: center;
  gap: 6px;
}

.cardIcon {
  width: 13px;
  height: 13px;
  color: #D02E27;
  flex-shrink: 0;
}

.cardTitle {
  font-size: 14px;
  font-weight: 700;
  color: #000;
}

.periodBadge {
  font-size: 11px;
  font-weight: 500;
  color: #D02E27;
  background: #f2effe;
  padding: 2px 8px;
  border-radius: 4px;
}

.statGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 14px;
}

.statItem {
  background: linear-gradient(135deg, #f7f5ff 0%, #f2effe 100%);
  border-radius: 8px;
  padding: 8px 10px;
}

.statLabel {
  font-size: 11px;
  color: #969799;
}

.statValue {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-top: 2px;
}

.profitPositive {
  color: #07c160;
}

.profitNegative {
  color: #ee0a24;
}

.cardActions {
  display: flex;
  justify-content: flex-end;
}

.btnPrimary {
  border: none;
  border-radius: 6px;
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;
  background: linear-gradient(135deg, #652b29 0%, #D02E27 100%);
  color: #ffffff;
}

.btnPrimary:active {
  opacity: 0.7;
}
</style>


// WEBPACK FOOTER //
// src/components/AITradeDepotMandate.vue